import React from 'react';
import classNames from 'classnames';
import './skeleton.scss';

type SkeletonVariant = 'circle' | 'text' | 'rect';

interface SkeletonProps {
  variant?: SkeletonVariant;
  width?: string | number;
  height?: string | number;
  className?: string;
  children?: React.ReactNode;
}

const toCssSize = (value?: string | number): string | undefined => {
  if (value === undefined) {
    return undefined;
  }
  return typeof value === 'number' ? `${value}px` : value;
};

const Skeleton = ({
  variant = 'rect',
  width,
  height,
  className,
  children,
}: SkeletonProps) => (
  <div
    aria-busy="true"
    aria-live="polite"
    className={classNames('skeleton', `skeleton--${variant}`, className)}
    style={{
      width: toCssSize(width),
      height: toCssSize(height),
    }}
  >
    {children}
  </div>
);

export default Skeleton;
